import { render, staticRenderFns } from "./user-ref-choice-message.vue?vue&type=template&id=280e5722&"
import script from "./user-ref-choice-message.vue?vue&type=script&lang=js&"
export * from "./user-ref-choice-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports